import { SkeletonBlock } from './SkeletonBlock';

interface NavButtonSkeletonProps {
  width?: number;
}

export const NavButtonSkeleton = ({ width = 75 }: NavButtonSkeletonProps) => {
  return (
    <div className="w-60 h-9 px-2 py-3.5 rounded inline-flex justify-start items-center gap-2">
      <SkeletonBlock className="size-5 rounded" />
      <SkeletonBlock className="h-3.5 rounded" style={{ width }} />
    </div>
  );
};
